var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResult(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "29.092px",
    height: "29.092px",
    viewBox: "0 0 29.092 29.092",
    enableBackground: "new 0 0 29.092 29.092",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_195",
    transform: "translate(-1266.114 -295.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    fill: "none",
    stroke: "#01C28D",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M1277.761,299.579h-10.147v23.193 h17.396l5.8-5.8v-4.349"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    fill: "none",
    stroke: "#01C28D",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    d: "M1283.558,296.679h10.147v10.147"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_25",
    fill: "none",
    stroke: "#01C28D",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    x1: 1293.707,
    y1: 296.679,
    x2: 1274.862,
    y2: 315.523
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResult);
export default __webpack_public_path__ + "static/media/result.458203c4f4c9974d2fae766ba53caeed.svg";
export { ForwardRef as ReactComponent };